<article class="no-mar-b" #examplesFound>
  <h2 class="heading-underline fit-sub-info-right">
    Examples found for {{dataRule.ruleData.name ? dataRule.ruleData.name : ""}}
    <span class="sub-info">
      {{recordsFoundLabel}} <span class="red">{{total}}</span> |
      Entity: <span class="green">{{entityMap[selectedEntity]}}</span>
    </span>
  </h2>
  <section class="table-overflow">
    <table mat-table [dataSource]="dataSource" class="table-striped">
      <!-- Columns -->
      <ng-container [matColumnDef]="column" *ngFor="let column of columnsToDisplay" [sticky]="column === 'fieldName'">
        <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
        <td mat-cell *matCellDef="let changeData">
          {{ changeData[column] }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
    </table>
    <div *ngIf="dataSource.length === 0" class="no-results">No examples found</div>
    <div *ngIf="examplesLoading" class="app-loading" @transitionLoading>
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
      </svg>
    </div>
  </section>

  <section class="footer-btns stretch-btns" [matTooltip]="inAChain && !firstInAChain ? 'Rule in Chained Rule Group' : null" >
    <button theme="nav"
            [disabled]="inAChain && !firstInAChain" type="button"
            (click)="applyToBullhorn()"
            [matTooltip]="fuzzy ? fuzzySearchTooltip : null">
      Apply changes to bullhorn
      <i class="bhi-bull"></i>
    </button>
  </section>
</article>
